// extracted by mini-css-extract-plugin
export default {"root":"Welcome__root--mYEmc"};